import React, { useState, useEffect, useCallback } from 'react';
import moment from 'moment';
import PropTypes from 'prop-types';

import { fetchGet } from '../../../../../../providers/Fetch';
import getAvailableDates from './getAvailableDates';
import DateSelector from './DateSelector';
import {
  datesObjType, fieldType, formType, requestParamsType,
} from './types';

const DependantDateSelector = ({
  field, form, requestParams, dates, setDates, ...rest
}) => {
  const [error, setError] = useState();
  const [lastRequestedDate, setLastRequestedDate] = useState(null);
  const { date, time } = form.values.service.pickup;
  const pickupDate = date && time ? moment(`${date} ${time.from}`).format() : null;
  const needsReload = lastRequestedDate !== pickupDate;
  const setVal = form.setFieldValue;
  const resetFields = useCallback(() => {
    setVal('service.delivery.date', '');
    setVal('service.delivery.time', '');
  }, [setVal]);
  useEffect(() => {
    const reloadData = async () => {
      await resetFields();
      try {
        setError(null);
        setDates({});
        const data = await fetchGet('/area/v2-slots', {
          params: {
            ...requestParams,
            pickupDate,
          },
        });
        const newDates = getAvailableDates(data);
        setDates(newDates);
      } catch (e) {
        setError(e.message);
      }
    };
    if (pickupDate && needsReload) {
      setLastRequestedDate(pickupDate);
      reloadData();
    }
  }, [pickupDate, needsReload, requestParams, resetFields, setDates]);
  return <DateSelector field={field} form={form} {...rest} remoteError={error} dates={dates} />;
};

DependantDateSelector.propTypes = {
  field        : fieldType.isRequired,
  form         : formType.isRequired,
  dates        : datesObjType.isRequired,
  setDates     : PropTypes.func.isRequired,
  requestParams: requestParamsType.isRequired,
};

export default DependantDateSelector;
